<template>
<!--  <div class="tag">-->
<!--    <div class="body" :class="type!='triangle' ? '' : ''" :style="styleObj">{{text}}</div>-->
<!--    <div class="right_border" v-if="type == 'triangle'">-->
<!--      <div class="top" :style="triangleTopStyleObj"></div>-->
<!--      <div class="bottom" :style="triangleBottomStyleObj"></div>-->
<!--    </div>-->
<!--  </div>-->
  <div :class="size=='small' ? 'tagSmall':'tagDefault'">
    <div class="textClass" :class="classList[colors.indexOf(color)]">
      <slot>{{text}}</slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'index',
    props:{
      type:{
        type:String,
        default:'rectangle'
      },
      size:{
        type:String,
        default:'default'
      },
      color:{
        type:String,
        default:'default'
      },
      text:{
        type:String,
        default:''
      },
      styleObj:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      triangleTopStyleObj:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      triangleBottomStyleObj:{
        type:Object,
        default:()=>{
          return {}
        }
      }
    },
    data(){
      return {
        colors:["default","grey",'white','tagText_1','tagText_2'],
        classList:["tagText","tagTextGrey",'textWhite','tagText_1','tagText_2'],
      }
    },
  }
</script>

<style scoped lang="less">
  .tagDefault{
    display: inline-block;
    position: relative;
    margin-right: 20px;
    .textClass{
      display: flex;
      align-items: center;
      padding: 0 10px 0 20px;
      height: 35px;
      border-radius: 3px;
      font-size: 16px;
      color: #FA9B00;
    }
    .textClass:after{
      content: '';
      display: block;
      position: absolute;
      right: -34px;
      bottom: 0px;
      width: 0;
      height: 0;
      margin-left: -10px;
      border: 18px solid transparent;
    }
	  
    .tagText{
      background: #FFF3DF;
      color: #FA9B00;
    }
	  
    .tagText:after{
      border-left-color: #FFF3DF;
    }
	  
	  
	  .tagText_1{
		  background: #FFE9DF;
		  color: #FF8A3D;
	  }
	  
	  .tagText_1:after{
		  border-left-color: #FFE9DF;
	  }
	  
	  
	  .tagText_2{
		  background: #FFCCC7;
		  color: #FF6E3D;
	  }
	  
	  .tagText_2:after{
		  border-left-color: #FFCCC7;
	  }
	  
    .tagTextGrey{
      background: #ECECEC;
      color: #666666;
    }
    .tagTextGrey:after{
      border-left-color: #ECECEC;
    }
    .textWhite{
      background: #ffffff;
      color: #666666;
    }
    .textWhite:after{
      border-left-color: #ffffff;
    }
  }
  .tagSmall{
    display: inline-block;
    position: relative;
    margin-right: 20px;
    .textClass{
      display: flex;
      align-items: center;
      padding: 0 5px 0 10px;
      height: 25px;
      border-radius: 3px;
      font-size: 12px;
    }
    .textClass:after{
      content: '';
      display: block;
      position: absolute;
      right: -24px;
      bottom: 0px;
      width: 0;
      height: 0;
      margin-left: -10px;
      border: 12px solid transparent;
    }
    .tagText{
      background:  #FFF3DF;
      color: #FA9B00;
    }
    .tagText:after{
      border-left-color:   #FFF3DF;
    }
    .tagTextGrey{
      background: #ECECEC;
      color: #666666;
    }
    .tagTextGrey:after{
      border-left-color:  #ECECEC;
    }
    .textWhite{
      background: #ffffff;
      color: #666666;
    }
    .textWhite:after{
      border-left-color:  #ffffff;
    }
  }
  .tag{
    display: flex;
    align-items: center;
    .body{
      font-size: 16px;
      color: #FA9B00;
      padding: 0 14px;
      background: #FFF3DF;
      border-top: 1px solid #FFD694;
      border-left: 1px solid #FFD694;
      border-bottom: 1px solid #FFD694;
      line-height: 35px;
      display: inline-block;
    }
    .rectangle{
      border-right: 1px solid #FFD694;
    }
    .right_border{
      position: relative;
      display: inline-block;
      .top{
        width: 0;
        height: 0;
        border-width: 18px 18px 18px 10px;
        border-style: solid;
        border-color: transparent;
        border-left-color: #FFF3DF;
        position: absolute;
        margin-top: 1px;
      }
      .bottom{
        width: 0;
        height: 0;
        border-width: 19px 19px 19px 11px;
        border-style: solid;
        border-color: transparent;
        border-left-color: #FFD694;
      }
    }
  }
</style>